module.exports = __webpack_public_path__ + "img/b52af597-e370-4187-93a0-f86b7aa0915a.e2d93398.jpg";